// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonCricle_wrapper__dbePE","outline":"ButtonCricle_outline__ET+E5"};